// fw Stat — the mock's .stat: a label over a big condensed tabular value.

import React from 'react';
import './Stat.css';

export const STAT_TONES = ['neutral', 'now', 'ok', 'sched', 'stop', 'warn'];

export function Stat({ label, value, tone = 'neutral', hint, className = '', ...rest }) {
  const t = STAT_TONES.includes(tone) ? tone : 'neutral';
  return (
    <div className={['fw-stat', `fw-stat--${t}`, className].filter(Boolean).join(' ')} data-tone={t} {...rest}>
      <div className="fw-stat__label">{label}</div>
      <div className="fw-stat__value fw-num">{value}</div>
      {hint ? <div className="fw-stat__hint">{hint}</div> : null}
    </div>
  );
}

export default Stat;
